import {
    useArtworkNotesPending,
    useArtworkUploadPending,
    useDimensionsPending,
    useQuantityPending
} from "../../redux/stateHooks";
import {useProductDetailsQuery} from "../useProductDetailsQuery";

export const useAddToCartDisabled = () => {
    const quantityPending = useQuantityPending();
    const dimensionsPending = isDimensionsPending();
    const artworkUploadPending = useArtworkUploadPending();
    const artworkNotesPending = useArtworkNotesPending();
    return quantityPending || dimensionsPending || artworkUploadPending || artworkNotesPending;
}

function isDimensionsPending() {
    const {
        model: {
            dynamicDimensions: {
                isDynamic,
                minWidth,
                maxWidth,
                minHeight,
                maxHeight
            }
        }
    } = useProductDetailsQuery();

    const {width, height} = useDimensionsPending();

    if (isDynamic && minWidth && maxWidth && minHeight && maxHeight) {
        return width || height;
    }

    // Not a dynamic dimension product, so not pending
    return false;
}
